// extracted by mini-css-extract-plugin
export var form = "Search-module--form--MwWk3";
export var search = "Search-module--search--udBJ2";
export var searchButton = "Search-module--searchButton--X9D1g";
export var searchIcon = "Search-module--searchIcon--2u0ef";
export var searchPlaceholder = "Search-module--searchPlaceholder--FTgiV";